import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.234 13.1704V15.464C16.2349 15.6769 16.1912 15.8876 16.1057 16.0827C16.0203 16.2778 15.8949 16.453 15.7377 16.5969C15.5805 16.7408 15.3949 16.8504 15.1928 16.9186C14.9908 16.9868 14.7766 17.0122 14.5642 16.993C12.2071 16.7374 9.94297 15.9335 7.95371 14.6459C6.10295 13.4721 4.53384 11.906 3.35779 10.0588C2.06326 8.06433 1.25765 5.79354 1.00622 3.4304C0.987076 3.21899 1.01225 3.00591 1.08014 2.80474C1.14802 2.60356 1.25713 2.4187 1.40052 2.26192C1.54391 2.10515 1.71843 1.97988 1.91298 1.89411C2.10753 1.80834 2.31785 1.76395 2.53053 1.76375H4.82849C5.20022 1.76009 5.56061 1.89148 5.84247 2.13342C6.12433 2.37535 6.30843 2.71133 6.36046 3.07872C6.45745 3.81272 6.63732 4.5334 6.89665 5.22703C6.99971 5.50067 7.02201 5.79806 6.96092 6.08397C6.89983 6.36987 6.7579 6.63231 6.55195 6.84017L5.57915 7.81111C6.66958 9.72513 8.25739 11.3099 10.1751 12.3982L11.1479 11.4273C11.3561 11.2217 11.6191 11.0801 11.9055 11.0191C12.192 10.9581 12.4899 10.9804 12.7641 11.0833C13.4591 11.3421 14.1811 11.5216 14.9165 11.6184C15.2886 11.6708 15.6284 11.8579 15.8713 12.144C16.1143 12.4302 16.2433 12.7955 16.234 13.1704Z",
			stroke: "#999999",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 4V4C12.2091 4 14 5.79086 14 8V8",
			stroke: "#999999",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 1H11C14.3137 1 17 3.68629 17 7V8",
			stroke: "#999999",
			strokeWidth: 2
		})
	]
});
export default SvgPhone;
